import {ModalFormFieldTypes} from 'components/formItems/FormGroup/FormGroup';
import moment, {Moment} from 'moment';
import {numberRules} from 'utils/formRules';

const fields: ModalFormFieldTypes[] = [
	{
		name: 'education',
		label: 'Ուսումնական հաստատություն',
		groupTitle: 'Ուսումնական հաստատություն',
		type: 'formGroup',
		minimaltem: 1,
		colProps: {
			xs: 24
		},
		inputs: [
			{
				name: 'educationTypeID',
				type: 'select',
				dictionaryApiPath: 'educationTypes',
				label: 'Տեսակ',
				selectProps: {
					placeholder: 'Տեսակ'
				}
			},
			{
				name: 'startDate',
				type: 'date',
				label: 'Ուսման սկիզբ',
				datePickerProps: {
					placeholder: 'Ուսման սկիզբ',
					format: 'YYYY',
					picker: 'year',
					disabledDate: (date: Moment) => {
						return date.year() > moment(new Date()).year();
					}
				},
				colProps: {
					xs: 24,
					lg: 4
				}
			},
			{
				name: 'endDate',
				type: 'date',
				label: 'Ուսման ավարտ',
				datePickerProps: {
					placeholder: 'Ուսման ավարտ',
					format: 'YYYY',
					picker: 'year',
					disabledDate: (date: Moment) => {
						return date.year() > moment(new Date()).year();
					}
				},
				colProps: {
					xs: 24,
					lg: 4
				}
			},
			{
				name: 'name',
				type: 'text',
				label: 'Անվանում',
				isRequired: (depValue: any) => !!!depValue,
				depFieldKey: 'number',
				depValue: () => true,
				onlyArmenian: true,
				inputProps: {
					placeholder: 'Անվանում'
				}
			},
			{
				name: 'number',
				label: 'Համար',
				type: 'text',
				isRequired: (depValue: any) => !!!depValue,
				isRequiredDep: 'name',
				inputProps: {
					placeholder: 'Համար'
				},
				rules: [numberRules],
				depFieldKey: ['educationTypeID', 'name'],
				depValue: [(depValue: any) => depValue && depValue !== 8, () => true]
			},
			{
				name: 'address',
				type: 'text',
				label: 'Երկիր/Մարզ/Քաղաք/Հասցե',
				onlyArmenian: true,
				inputProps: {
					placeholder: 'Երկիր/Մարզ/Քաղաք/Հասցե'
				}
			},
			{
				name: 'profession',
				type: 'text',
				label: 'Մասնագիտություն',
				onlyArmenian: true,
				inputProps: {
					placeholder: 'Մասնագիտություն'
				},
				depFieldKey: 'educationTypeID',
				depValue: (depValue: any) => [1, 6, 7, 8].some(i => i === depValue)
			}
		]
	}
];

export default fields;
